<template>
    <div class="popup">
        <div class="popup__wrapper">
            <div class="card">
                <div class="card__header">
                    <h2>{{ title }}</h2>
                    <i class="fas fa-times close" @click="$emit('close')"></i>
                </div>
                <div class="card__content">
                    <slot>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['title']
    };
</script>

<style scoped lang="scss">
    .popup {
        position:fixed;
        top: 0;
        left: 0;
        background-color: rgba(13, 55, 92, 0.7);
        width: 100%;
        height: 100%;
        z-index: 100;
        display: flex;
        justify-content: center;
        align-items: center;

        &__wrapper {
            width: 800px;
            opacity: 1;
            animation: fadeIn 0.5s;
        }

        .card__content img {
            width: 100%;
            padding-left: 50px;
        }

        .close {
            font-size: 30px;
            position: absolute;
            right: 20px;
            top: 18px;
            cursor: pointer;
        }
    }

    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
</style>
  